import React, {useContext, useEffect, useState} from "react";
import {companyService, systemService} from "../../../services";
import {Button, Col, Modal, notification, Row} from "antd";
import SelectField from "../../select-field";
import Spinner from "../../spinner";
import i18n from "../../../i18n";
import {AppContext} from "../../../contexts/app-context";

export default function ModalChangeCompanyType({isShow, setIsShow, orderId, setIsNeedUpdate}) {
  const [loading, setLoading] = useState(false);
  const [companyTypesList, setCompanyTypesList] = useState([]);
  const [translatedCompanyTypesList, setTranslatedCompanyTypesList] = useState([]);
  const [companyType, setCompanyType] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const appContext = useContext(AppContext);

  useEffect(() => {
    const companyTypes = companyTypesList
        .filter((companyType) => companyType.Id !== 4)
        .map((companyType) => {
      return Object.assign(companyType, {
        Name: i18n.t(`constants.companyType.${companyType.Id}.name`),
        Title: i18n.t(`constants.companyType.${companyType.Id}.title`)
      })
    });
    
    setTranslatedCompanyTypesList(companyTypes);
  },[appContext.lang.lang])
  
  const companyTypes = [];
  useEffect(() => {
    if (isShow) {
      setLoading(true);
      systemService.getCompanyTypeList()
        .then(res => {
          const companyTypes = res
              .filter((companyType) => companyType.Id !== 4)
              .map((companyType) => {
            return Object.assign(companyType, {
              Name: i18n.t(`constants.companyType.${companyType.Id}.name`),
              Title: i18n.t(`constants.companyType.${companyType.Id}.title`)
            })
          });
          setCompanyTypesList(res);
          setTranslatedCompanyTypesList(companyTypes);
          setLoading(false);
        });
    }
  }, [isShow]);

  const submitBtnStyle = {
    width: "200px",
    height: "43px",
    background: "#1CAA53",
    position: "static",
    borderRadius: "10px",
    color: "white",
    borderColor: "transparent",
  };

  const onSignUp = () => {
    setIsDisabled(true);
    const typeName = companyTypesList.find((item) => item.Id === companyType);
    companyService.changeTypeByOrderId(orderId, typeName.Name)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.changeTypeByOrderId'), description: response.message,
        });
        setIsShow(false);
        setIsNeedUpdate(true);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.changeTypeByOrderId'), description: err,
        });
      })
      .finally(() => {
        setIsDisabled(false);
      })
  }

  return (
    <Modal
      title={<div>{i18n.t('modals.modalChangeCompanyType.title')}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      forceRender={true}
      footer={
        <Button htmlType="submit" key="submit" type="primary"
                style={submitBtnStyle}
                onClick={() => onSignUp()}
                disabled={companyType === "" || isDisabled}
        >{i18n.t('main.buttons.send')}</Button>
      }
    >
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        <Row>
          <Col lg={8} sm={24}>
            <SelectField
              title={i18n.t('modals.modalChangeCompanyType.fields.type.title')}
              name="type"
              selectedValue={companyType}
              values={translatedCompanyTypesList}
              onChange={(name) => {
                setCompanyType(name);
              }}
              getErrors={() => {
              }}
              placeholder={i18n.t('modals.modalChangeCompanyType.fields.type.placeholder')}
              notFoundText={null}
              showArrow={true}
              style={{width: "100%"}}
            />
          </Col>
        </Row>
      </Spinner>
    </Modal>
  )
}
